import { getPartnerNavLinks, managePartnerBaseLink, PARTNER_NAV_ITEMS } from '@atlassian/mpac-utils';
import queryString from 'query-string';
import { reportNameToLabel } from './ReportDetails.constants';
export const getReportBreadcrumb = (partnerId, partnerName, reportName, sourceParams, text) => {
  const baseRoute = managePartnerBaseLink();
  const partnerNavLinks = getPartnerNavLinks();
  return [{
    name: partnerName,
    href: baseRoute.expand({
      id: partnerId
    })
  }, {
    name: 'Reports',
    href: partnerNavLinks[PARTNER_NAV_ITEMS.SALE_REPORTS].expand({
      id: partnerId
    })
  }, {
    name: reportNameToLabel[reportName],
    href: "".concat(partnerNavLinks[PARTNER_NAV_ITEMS.REPORTS].expand({
      id: partnerId,
      key: reportName
    }), "?").concat(queryString.stringify(sourceParams))
  }, {
    name: text
  }];
};
export const getUniqueContacts = contactDetails => {
  let partnerContacts = [];
  if (contactDetails.billingContact && contactDetails.technicalContact) {
    partnerContacts = [contactDetails.billingContact, ...(contactDetails.billingContact.email !== contactDetails.technicalContact.email ? [contactDetails.technicalContact] : [])];
    return partnerContacts;
  } else if (contactDetails.technicalContact) return [contactDetails.technicalContact];else if (contactDetails.billingContact) return [contactDetails.billingContact];
};
export const getReportDetail = (reports, reportName, params) => {
  if (reportName === 'transactions' && params.invoiceLineItemId) {
    var _reports;
    reports = (_reports = reports) === null || _reports === void 0 ? void 0 : _reports.filter(report => report.invoiceLineItemId === params.invoiceLineItemId);
  }
  if (reportName === 'licenses' && params.text) {
    var _reports2;
    reports = (_reports2 = reports) === null || _reports2 === void 0 ? void 0 : _reports2.filter(report => report.licenseId === params.text || report.hostEntitlementNumber === params.text);
  }
  if (reports && reports.length > 0) {
    return reports[0];
  }
};